import { html } from "lit-element";
import { DrawSVGBaseModule } from "../../ModuleBase/svg-base-module";

export class DrawSdvHor2Module extends DrawSVGBaseModule {
	constructor(canvas) {
		super(canvas);

		this.name = "sdv-hor-2";
		this.icon = svg_sdv_hor_2;
	}
}

window.customElements.define("inspx-draw-sdv-hor-2-module", DrawSdvHor2Module);

const svg_sdv_hor_2 = html`
<svg width="90" height="30" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
 <g>
  <title>Layer 1</title>
  <line id="svg_2" y2="30" x2="30" y1="30" x1="0" stroke="#444444" fill="none"/>
  <line id="svg_3" y2="15.07031" x2="75.24609" y1="15.07031" x1="45.24609" stroke="#444444" fill="none" transform="rotate(90 60.24609375,15.070312500000005) "/>
  <rect id="svg_1" height="30" width="90" y="0" x="0" stroke="#444444" fill="#ffffff"/>
  <rect stroke="#000000" stroke-width="0" id="svg_5" height="29.28303" width="29.05777" y="0.53543" x="60.5764" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" fill="#aaa7a7"/>
  <text stroke="#000000" transform="rotate(-0.06877446174621582 44.55663681030211,14.723796844482177) matrix(1.8460991017711432,0,0,1.2207685708999634,2.4569240583170897,-10.912342863340838) " xml:space="preserve" text-anchor="middle" font-family="Sans-serif" font-size="24" id="svg_4" y="29.29964" x="22.74404" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#000000">SDV</text>
  <line y2="14.78384" x2="43.93414" y1="14.78384" x1="13.93414" stroke="#444444" fill="none" transform="rotate(90 28.934143066406254,14.783843994140627) " id="svg_6"/>
 </g>
</svg>`;
